export default __webpack_public_path__ + "static/media/summoners_rift.55e6ed75.jpg";